// --- Dependencies -------------------------------------------------------------------------------
import { NavLink } from "react-router-dom";
// --- Our Modules --------------------------------------------------------------------------------
import useNavTabs from "@/hooks/useNavTabs";
import StoreSwitcher from "@/UI/components/StoreSwitcher";
import "./styles.css";

// --- Types --------------------------------------------------------------------------------------

type Props = {
    isOpen: boolean;
};

// --- Logic --------------------------------------------------------------------------------------

export default function SideBar({ isOpen }: Props) {
    const { mainTabs, bottomTabs } = useNavTabs();

    return (
        <aside className="side-bar" data-open={isOpen}>
            <StoreSwitcher />

            <div className="side-bar-divider" />

            <nav className="side-bar-nav">
                {mainTabs.map((tab) => (
                    <NavLink
                        key={tab.path}
                        to={tab.path}
                        end={tab.path === "/"}
                        className={({ isActive }) => `side-bar-btn${isActive ? " active" : ""}`}
                    >
                        <img className="side-bar-btn-icon side-bar-btn-icon--dark" src={`/icons/side-bar/${tab.icon}-icon-dark.svg`} alt="" />
                        <img className="side-bar-btn-icon side-bar-btn-icon--white" src={`/icons/side-bar/${tab.icon}-icon-white.svg`} alt="" />
                        <span className="side-bar-btn-label">{tab.label}</span>
                    </NavLink>
                ))}
            </nav>

            <div className="side-bar-spacer" />

            <nav className="side-bar-bottom">
                {bottomTabs.map((tab) => (
                    <NavLink key={tab.path} to={tab.path} className={({ isActive }) => `side-bar-btn${isActive ? " active" : ""}`}>
                        <img className="side-bar-btn-icon side-bar-btn-icon--dark" src={`/icons/side-bar/${tab.icon}-icon-dark.svg`} alt="" />
                        <img className="side-bar-btn-icon side-bar-btn-icon--white" src={`/icons/side-bar/${tab.icon}-icon-white.svg`} alt="" />
                        <span className="side-bar-btn-label">{tab.label}</span>
                    </NavLink>
                ))}
            </nav>
        </aside>
    );
}
